import { Skeleton } from '@material-ui/lab';
import Box from 'components/atoms/Box/Box';
import Divider from 'components/atoms/Divider/Divider';
import { Link } from 'react-router-dom';
import { Fragment } from 'react';
import { createElement } from 'react';
import { useRecoilValueLoadable } from 'recoil';
import { ROUTE_MY_PROFILE } from 'routes';
import { useTranslation } from 'react-i18next';

const ChildComponent = (props) => {
  const { component, ...rest } = props;
  return createElement(component, { ...rest });
};

export const Loadable = (props) => {
  const { value, component } = props;
  const { state, contents } = useRecoilValueLoadable(value);
  const { t } = useTranslation();

  switch (state) {
    case 'hasValue':
      return <ChildComponent component={component} data={contents} />;
    case 'loading':
      return (
        <Fragment>
          <Box my={3}>
            {/* TODO: create skeleton ui component */}
            <Skeleton animation="wave" variant="text" />
            <Skeleton animation="wave" variant="text" />
            <Skeleton animation="wave" variant="rect" height={200} />
            <Divider />
            <Skeleton animation="wave" variant="text" />
            <Skeleton animation="wave" variant="text" />
            <Skeleton animation="wave" variant="rect" height={200} />
          </Box>
        </Fragment>
      );
    case 'hasError': // TODO: (Damir) implement error handling
      let { response } = contents;
      if (response && response.status === 500) {
        if (
          response.data &&
          response.data.detail === 'Genotype not available'
        ) {
          return (
            <Box textAlign="center" mb={3}>
              {t('dna24.profile.uploadDna')}{' '}
              <Link to={ROUTE_MY_PROFILE}>{t('dna24.profile.here')}</Link>
            </Box>
          );
        }
      } else {
        return 'error contents ' + contents;
      }

    default:
      return '';
  }
};
